import { render, staticRenderFns } from "./PlainInput.vue?vue&type=template&id=4195107e&scoped=true&"
import script from "./PlainInput.vue?vue&type=script&lang=js&"
export * from "./PlainInput.vue?vue&type=script&lang=js&"
import style0 from "./PlainInput.vue?vue&type=style&index=0&id=4195107e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195107e",
  null
  
)

export default component.exports